import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikFieldString } from 'Components/FormikComponents';
import { DescriptionInputType } from './formTypes';

type Props = {
    formikProps: DescriptionInputType;
    className?: string;
};

const DescriptionInput = ({ formikProps, className }: Props) => {
    const { t } = useTranslation();
    const { handleBlur, handleChange, errors } = formikProps;

    return (
        <FormikFieldString
            className={className}
            name='description'
            label={t('List Description (Optional)')}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={!!errors.description}
            errorMsg={errors.description}
        />
    );
};

export default React.memo(DescriptionInput);
